/**
 * signalDefinitions.js — Operational signal type registry.
 *
 * Each signal represents a behavioral pattern detected from the
 * session event timeline. Signals are deterministic — no ML.
 */

export const SIGNALS = Object.freeze({
  FOLLOW_UP_RISK:          "FOLLOW_UP_RISK",
  INACTIVE_FAMILY_PATTERN: "INACTIVE_FAMILY_PATTERN",
  HIGH_VISIT_ACTIVITY:     "HIGH_VISIT_ACTIVITY",
  ADMIN_ATTENTION:         "ADMIN_ATTENTION",
  AUDIT_INVESTIGATION:     "AUDIT_INVESTIGATION",
  PRAYER_FOCUS:            "PRAYER_FOCUS",
  LEADERSHIP_REVIEW:       "LEADERSHIP_REVIEW",
  MEMBER_RECOVERY_FLOW:    "MEMBER_RECOVERY_FLOW",
});

/** Human-readable metadata for each signal type. */
export const SIGNAL_META = {
  [SIGNALS.FOLLOW_UP_RISK]: {
    label:       "Seguimiento pendiente",
    description: "Hay entidades pastorales recientes sin acción de seguimiento",
    mood:        "reflective",
  },
  [SIGNALS.INACTIVE_FAMILY_PATTERN]: {
    label:       "Revisión de familias",
    description: "Patrón de navegación por familias del distrito",
    mood:        "pastoral-care",
  },
  [SIGNALS.HIGH_VISIT_ACTIVITY]: {
    label:       "Alta actividad de visitas",
    description: "Sesión enfocada en visitas pastorales",
    mood:        "neutral",
  },
  [SIGNALS.ADMIN_ATTENTION]: {
    label:       "Revisión mensual",
    description: "Actividad administrativa reciente",
    mood:        "neutral",
  },
  [SIGNALS.AUDIT_INVESTIGATION]: {
    label:       "Auditoría activa",
    description: "Revisión de registros del sistema en curso",
    mood:        "neutral",
  },
  [SIGNALS.PRAYER_FOCUS]: {
    label:       "Ministerio de oración",
    description: "Sesión enfocada en intercesión y oración",
    mood:        "reflective",
  },
  [SIGNALS.LEADERSHIP_REVIEW]: {
    label:       "Revisión de liderazgo",
    description: "Revisión de estructura directiva del distrito",
    mood:        "neutral",
  },
  [SIGNALS.MEMBER_RECOVERY_FLOW]: {
    label:       "Seguimiento activo",
    description: "Persona abierta con acción de seguimiento iniciada",
    mood:        "pastoral-care",
  },
};
